import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useWorkforceStore from '../../store'
import { defer } from 'react-router-dom'
import dayjs from 'dayjs'

export default async function loader({ params }) {
  logger.debug(
    '[loader] About to await AppState being ready in Approvals loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Approvals loader')

  let requestPromise
  switch (params.type) {
    case 'leave':
      requestPromise = Promise.all([
        useWorkforceStore.getState().getLeaveRequest(params.requestId),
        // if this is a leave request we need to get the leave types as well.
        useWorkforceStore.getState().leaveTypes.length > 0
          ? useWorkforceStore.getState().leaveTypes
          : useWorkforceStore.getState().getLeaveTypes(),
      ]).then((result) => {
        return useWorkforceStore
          .getState()
          .getOverlappingLeaveAndUnavailability(
            result[0].startDateTime,
            result[0].endDateTime
          )
      })
      break
    case 'unavailability':
      requestPromise = useWorkforceStore
        .getState()
        .getUnavailabilityRequest(params.requestId)
        .then((result) => {
          return useWorkforceStore
            .getState()
            .getOverlappingLeaveAndUnavailability(
              dayjs(result.from),
              dayjs(result.to)
            )
        })
      break
    case 'shift-request':
      requestPromise = useWorkforceStore
        .getState()
        .getShiftRequest(params.requestId)
      break
    default:
      logger.error(
        `[loader] Invalid request type: ${params.type}. Expected 'leave', 'unavailability' or 'shift-request'.`
      )
      break
  }

  const staffMembers =
    useWorkforceStore.getState().activeStaffMembers.length > 0
      ? useWorkforceStore.getState().activeStaffMembers
      : useWorkforceStore.getState().getStaffMembers()

  return defer({
    data: Promise.all([requestPromise, staffMembers])
      .then(() => true)
      .catch((error) => {
        logger.error('Requests Promise.all error', error)
        return false
      }),
  })
}
